import type { WebUrl } from '../types/webUrl.types';

const WHITESPACE_RUN = /\s+/g;
const UNNAMED_WEB_URL = 'web URL';
const NAME_PART_SEPARATOR = ' - ';

export function toSingleSpacedText(text: string): string {
  return text.replace(WHITESPACE_RUN, ' ').trim();
}

export function getWebUrlActionName(webUrl: WebUrl): string {
  const title = webUrl.title ?? UNNAMED_WEB_URL;
  if (!webUrl.description) return title;
  return `${title}${NAME_PART_SEPARATOR}${toSingleSpacedText(webUrl.description)}`;
}
